import { Injectable, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CookieConsentService } from './cookie-consent.service';

export const DEFAULT_LANGUAGE = 'en-GB';
const LANGUAGE_STORAGE_KEY = 'translationLanguage';

@Injectable({ providedIn: 'root' })
export class LanguageService {
  private readonly translate = inject(TranslateService);
  private readonly cookieConsentService = inject(CookieConsentService);

  initializeLanguage(): void {
    const storedLanguage = sessionStorage.getItem(LANGUAGE_STORAGE_KEY);
    const lang = storedLanguage || DEFAULT_LANGUAGE;

    this.translate.setDefaultLang(DEFAULT_LANGUAGE);
    this.setLanguage(lang);
  }

  setLanguage(lang: string): void {
    sessionStorage.setItem(LANGUAGE_STORAGE_KEY, lang);

    this.translate.use(lang);

    this.cookieConsentService.setLanguage(lang);
  }
}
